export const scrollToElementByID = (
  ID: string,
  scrollBehavior: ScrollBehavior = 'smooth',
  block: ScrollLogicalPosition = 'center',
) =>
  document
    .getElementById(ID)
    ?.scrollIntoView({ behavior: scrollBehavior, block });
